import React, { useState, useEffect } from "react";
import { useBosAutoCompletion } from "../../components/BosAutoCompletion";
import * as Constants from "../logic/Constants";

// Externals
import cn from "classnames";

// DevExtreme components
import { Toolbar, Item } from 'devextreme-react/toolbar';
import { Autocomplete } from 'devextreme-react/autocomplete'; // eslint-disable-line no-unused-vars  

// Component styles
import classes from "./ToolbarWidget.module.scss";

export function ToolbarWidget(props) {
  const { ui, data, config, doAction, getAutocompleteSuggestions } = props;
  const [directContent, setDirectContent] = useState("");

  let widgetId = ui.id;
  let autocompleteId = config ? config.AutocompleteId : null;
  let buttons = config ? config.Buttons : null;

  let disabledByUi = ui.readonly;
  let disabledByData = data && data.readonly;
  let disabledToolbar = disabledByUi || disabledByData;

  const { store: autoCompletionStore } = useBosAutoCompletion(autocompleteId, getAutocompleteSuggestions);

  useEffect(() => {
    //console.log("ToolbarWidget data of " + ui.id + ": ", data);
  }, [data]);

  const onButtonClick = async (event, actionId) => {
    doAction(actionId);
  };

  const setSelection = (value) => {
    if (value && value.selectedItem && value.selectedItem.itemId) {
      doAction("DIRECT", value.selectedItem.itemId);
      setDirectContent("");
    }
  };

  const findIcon = (actionId) => {
    switch (actionId) {
      case Constants.TOOLBAR_WIDGET_NEW_ACTION:
        return "plus";
      case Constants.TOOLBAR_WIDGET_DELETE_ACTION:
        return "close";
      case Constants.TOOLBAR_WIDGET_PREV_ACTION:
        return "arrowleft";
      case Constants.TOOLBAR_WIDGET_NEXT_ACTION:
        return "arrowright";
      case Constants.TOOLBAR_WIDGET_SEARCH_ACTION:
        return "search";
      case Constants.TOOLBAR_WIDGET_RELOAD_ACTION:
        return "refresh";
      case Constants.TOOLBAR_WIDGET_UNDO_ACTION:
        return "undo";
      case Constants.TOOLBAR_WIDGET_LOCK_ACTION:
        return "edit";
      case Constants.TOOLBAR_WIDGET_SAVE_ACTION:
        return "save";
      default:
        return null;
    }
  };

  const isControlEnabled = actionId => {
    if (disabledToolbar) return false;
    if (data && data.content) {
      return data.content.includes(actionId);
    }
    return false;
  };

  const isDirect = actionId => {
    return actionId === "DIRECT";
  };

  const renderDirectTextBox = (control) => {
    return (
      <Item
        key={control.ActionId}
        widget="dxAutocomplete"
        location="before"
        locateInMenu="never"
        disabled={!isControlEnabled(control.ActionId)}
        options={{
          value: directContent,
          dataSource: autoCompletionStore,
          hint: control.Tooltip,
          valueExpr: "displayData",
          searchMode: "startswith",
          onSelectionChanged: e => setSelection(e),
          itemRender: renderDropdownItem,
          height: "1.8em"
        }}
      />
    );
  };

  const renderDropdownItem = (data) => {
    return <span>{data.displayData}</span>;
  };

  const renderActionButton = (control) => {
    let isSupported = findIcon(control.ActionId) !== null;
    return isSupported
      ? (
        <Item
          key={control.ActionId}
          widget="dxButton"
          location="before"
          locateInMenu="auto"
          showText="inMenu"
          disabled={!isControlEnabled(control.ActionId)}
          options={{
            icon: findIcon(control.ActionId),
            hint: control.Tooltip,
            text: control.DisplayText,
            stylingMode: "text",
            onClick: e => onButtonClick(e, control.ActionId)
          }}
        />
      )
      : null;
  };

  const renderToolbar = () => {
    return (
      <Toolbar
        className={cn(classes.toolbar, "dx-theme-border-color")}
        id={widgetId}
        style={{height: ui.controlHeight + "em"}}
      >
        {buttons.map(control => (
          isDirect(control.ActionId)
            ? renderDirectTextBox(control)
            : renderActionButton(control)
        ))}
      </Toolbar>
    );
  };

  return config
    ? renderToolbar()
    : null;
}
